<template lang="pug" src="./custom-home-testimonials.pug"></template>

<script>
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      show: 0,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.4]
      }
    }
  },
  props: ['props'],
  mixins: [onScroll],
  async created () {
    setInterval(() => {
      if (this.show === (this.props.slides.length - 1)) {
        this.show = 0
      } else {
        this.show++
      }
    }, 8000)
  },
  methods: {
    moveSlide (i) {
      this.show = i
    },
    incrementSlide () {
      if (this.show === (this.props.slides.length - 1)) {
        this.show = 0
      } else {
        this.show++
      }
    },
    decrementSlide () {
      if (this.show === 0) {
        this.show = this.props.slides.length - 1
      } else {
        this.show--
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-home-testimonials/custom-home-testimonials.vue